export enum FooterStatus {
  GROUP_FOOTER = 'Big Footer',
  FOOTER = 'Small Footer',
}
